import { render } from "./Tables.vue?vue&type=template&id=ba9bd430"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=ba9bd430&lang=scss"
script.render = render

export default script